import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import className from "classnames";
import { HorizontalAlignments, VerticalAlignments } from "./AlignmentTypes";

var Alignment = function Alignment(_ref) {
  var _className;

  var children = _ref.children,
      _ref$horizontal = _ref.horizontal,
      horizontal = _ref$horizontal === void 0 ? HorizontalAlignments.LEFT : _ref$horizontal,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === void 0 ? VerticalAlignments.TOP : _ref$vertical;
  var getClassName = getClassNameFactory(Alignment.displayName);
  var horizontalCapitalized = horizontal.charAt(0).toUpperCase() + horizontal.slice(1);
  var verticalCapitalized = vertical.charAt(0).toUpperCase() + vertical.slice(1);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: className((_className = {}, _defineProperty(_className, "horizontal".concat(horizontalCapitalized), true), _defineProperty(_className, "vertical".concat(verticalCapitalized), true), _className))
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, children));
};

Alignment.displayName = "Alignment";
export default Alignment;